import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
  combineReducers,
} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import reduxThunk from "redux-thunk";
import gaMiddleware from "@analytics/middleware";
import { connectRoutes } from "redux-first-router";
import router from "./router";
import options from "./router/options";
import * as reducers from "./reducers";
import * as actionCreators from "./actions";

const service = {};

const configureStore = (preLoadedState, extendOptions) => {
  const { reducer, middleware, enhancer, thunk, initialDispatch } = connectRoutes(
    router,
    Object.assign({}, options, extendOptions)
  );

  const rootReducer = combineReducers({ ...reducers, location: reducer });
  const middlewares = applyMiddleware(
    middleware,
    reduxThunk.withExtraArgument({ service }),
    gaMiddleware
  );

  const enhancers = composeEnhancers(enhancer, middlewares);
  const store = createStore(rootReducer, preLoadedState, enhancers);
  /*
  if (module.hot) {
    module.hot.accept('./reducers/index', () => {
      const reducers = require('./reducers/index');
      const rootReducer = combineReducers({ ...reducers, location: reducer });
      store.replaceReducer(rootReducer);
    });
  }
*/
  return { store, thunk, initialDispatch };
};

const composeEnhancers = (...args) =>
  typeof window !== "undefined"
    ? composeWithDevTools({ actionCreators })(...args)
    : compose(...args);

export default configureStore;
